/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Select, DatePicker, Pagination, Spin } from 'antd';
import LoadingTable from '../../components/LoadingTable';
import { formatNumber, formatTimestamp, truncateText } from '../Utils';
import { AdminApi } from '../../api/Admin';
import '../Users/style.scss';
import './style.scss';

import { Noti } from '../../components/Noti/toast';
import { LoadingOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;

async function handleCopy(id: any) {
    try {
        await navigator.clipboard.writeText(id);
        Noti('success', `Copied`, 3000)
    } catch (err) {
        Noti('error', `Failed to copy!`, 3000)
    }
}

enum ReconciliationStatus {
    PENDING_METEORA_CONFIRM = 'pending_meteora_confirm',
    PENDING_PWC_CONFIRM = 'pwnding_pwc_confirm',
    AWAITING_TOPUP = 'awaiting_topup',
    PENDING_PWC_FINAL_CONFIRM = 'pending_pwc_final_confirm',
    COMPLETED = 'completed',
}

const ReconciliationModal = ({ data, onClose, getReconciliationData, loadingAction, setLoadingAction }: any) => {
    const [hashValue, setHashValue] = useState('');
    if (!data) return null;

    const handlePartnerConfirm = async () => {
        try {
            if (loadingAction) return;
            setLoadingAction(true);
            let params = {
                id: data.id,
            }
            const res = await AdminApi.PartnerConfirmReconciliation(params);
            if (res?.status === 201 || res?.status === 200) {
                Noti('success', 'Partner confirmation successful', 3000);
                getReconciliationData();
                onClose();
            } else {
                Noti('error', 'Partner confirmation failed', 3000);
            }

        } catch (err: any) {
            console.log(err);
            Noti('error', err?.message || 'Partner confirmation failed', 3000);
        } finally {
            setLoadingAction(false);
        }
    }

    const handlePwcConfirm = async () => {
        try {
            if (loadingAction) return;
            setLoadingAction(true);
            let params = {
                id: data.id,
            }
            const res = await AdminApi.PwcConfirmReconciliation(params);
            console.log('handlePwcConfirm', res);
            if (res?.status === 201 || res?.status === 200) {
                Noti('success', 'PWC confirmation successful', 3000);
                getReconciliationData();
                onClose();
            } else {
                Noti('error', 'PWC confirmation failed', 3000);
            }
        } catch (err: any) {
            console.log(err);
            Noti('error', err?.message || 'PWC confirmation failed', 3000);
        } finally {
            setLoadingAction(false);
        }
    }

    const handlePartnerUpdateHash = async () => {
        try {
            if (loadingAction) return;
            setLoadingAction(true);
            let params = {
                id: data.id,
                hash: hashValue,
            }
            const res = await AdminApi.PartnerUpdateHash(params);
            if (res?.status === 201 || res?.status === 200) {
                Noti('success', 'Partner update hash successful', 3000);
                getReconciliationData();
                onClose();
            } else {
                Noti('error', res?.data?.message || 'Partner update hash failed', 3000);
            }
        } catch (err: any) {
            console.log(err);
            Noti('error', err?.message || 'Partner update hash failed', 3000);
        } finally {
            setLoadingAction(false);
        }
    }

    const handlePwcFinalConfirm = async () => {
        try {
            if (loadingAction) return;
            setLoadingAction(true);
            let params = {
                id: data.id,
            }
            const res = await AdminApi.PwcFinalConfirmReconciliation(params);
            if (res?.status === 201 || res?.status === 200) {
                Noti('success', 'PWC final confirmation successful', 3000);
                getReconciliationData();
                onClose();
            } else {
                Noti('error', res?.data?.message || 'PWC final confirmation failed', 3000);
            }
        } catch (err: any) {
            console.log(err);
            Noti('error', err?.message || 'PWC final confirmation failed', 3000);
        } finally {
            setLoadingAction(false);
        }
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h3>
                        Reconciliation for {formatTimestamp(data.updatedAt)}
                    </h3>
                    <button
                        onClick={onClose}
                        className="close-button">
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <div className="modal-step">
                        <h4>Step 1: Volume Review</h4>
                        <div className="info-box">
                            <span>Total Settlement Volume</span>
                            <span>
                                {formatNumber(data.total_volume, 2)} USDT
                            </span>
                        </div>
                    </div>
                    <div className="modal-step">
                        <h4>Step 2: Dual Confirmation</h4>
                        <div className="confirmation-grid">
                            <div
                                style={{
                                    justifyContent: 'flex-start'
                                }}
                                className="info-box column">
                                <div>Meteora Pay Status</div>
                                <div
                                    className={data.partner_confirmation ? 'confirmed' : 'pending'}>
                                    {data.partner_confirmation ? 'Confirmed' : 'Pending'}
                                </div>
                                {
                                    data.status === ReconciliationStatus.PENDING_METEORA_CONFIRM ? (
                                        <>
                                            {loadingAction ? (
                                                <>
                                                    <button
                                                        className="button primary full-width"
                                                    >
                                                        Meteora Confirm <Spin indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />} />
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    className="button primary full-width"
                                                    onClick={handlePartnerConfirm}
                                                >
                                                    Meteora Confirm Volume
                                                </button>
                                            )}
                                        </>
                                    ) : null
                                }
                            </div>
                            <div
                                className="info-box column"
                                style={{
                                    justifyContent: 'flex-start'
                                }}>

                                <div>PWC Status</div>
                                <div
                                    className={data.pwc_confirmation ? 'confirmed' : 'pending'}>
                                    {data.pwc_confirmation ? 'Confirmed' : 'Pending'}
                                </div>
                                {
                                    data.status === ReconciliationStatus.PENDING_PWC_CONFIRM ? (
                                        <>
                                            {loadingAction ? (
                                                <button
                                                    className="button secondary full-width"
                                                >
                                                    PWC Confirm <Spin indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />} />
                                                </button>
                                            ) : (
                                                <button
                                                    className="button secondary full-width"
                                                    onClick={handlePwcConfirm}
                                                >
                                                    PWC Confirm Volume
                                                </button>
                                            )
                                            }
                                        </>
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>

                    {(data.status === ReconciliationStatus.AWAITING_TOPUP && !data?.hash) && (
                        <div className="modal-step">
                            <h4>Step 3: Top-up Liquidity Pool</h4>
                            <div className="info-box column">
                                <div>Amount to be sent by Meteora Pay:</div>
                                <div className="large-amount">{formatNumber(data.total_volume, 2)} USDT</div>
                                <div className="small-text">Please send to the designated BSC (BEP-20) funding address.</div>
                                <div className="tx-hash-input-group">
                                    <label>Submit Top-up Transaction Hash</label>
                                    <div className="input-with-button">
                                        <input
                                            type="text"
                                            className="form-input"
                                            placeholder="0x..."
                                            value={hashValue}
                                            onChange={(e) => setHashValue(e.target.value)}
                                            disabled={loadingAction}
                                        />
                                        {loadingAction ? (
                                            <>
                                                <button
                                                    className="button primary"
                                                    disabled={loadingAction}
                                                >
                                                    <Spin indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />} />
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    className="button primary"
                                                    onClick={handlePartnerUpdateHash}
                                                    disabled={loadingAction || !hashValue.trim()}
                                                >
                                                    Submit
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {(data.status === ReconciliationStatus.PENDING_PWC_FINAL_CONFIRM &&
                        data?.hash) || data?.status === ReconciliationStatus.COMPLETED ? (
                        <div className="modal-step">
                            <h4>Step 3: Top-up Liquidity Pool</h4>
                            <div className="info-box column">
                                <div>Amount to be sent by Meteora Pay:</div>
                                <div className="large-amount">{formatNumber(data.total_volume, 2)} USDT</div>
                                <div className="small-text">Please send to the designated BSC (BEP-20) funding address.</div>
                                <div className="tx-hash-input-group">
                                    <label>Submit Top-up Transaction Hash</label>
                                    <div className="input-with-button">
                                        <input
                                            type="text"
                                            className="form-input"
                                            placeholder="0x..."
                                            value={data?.hash}
                                            disabled={true}
                                        />
                                        <button
                                            className="button primary"
                                            disabled={true}
                                        >
                                            Submited
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (null)}

                    {(data.status === ReconciliationStatus.PENDING_PWC_FINAL_CONFIRM && data?.hash) && (
                        <div className="modal-step">
                            <h4>Step 4: PWC Receipt Confirmation</h4>
                            <div className="info-box receipt-box receipt-box-completed">
                                <div>Meteora Pay has submitted Tx Hash:</div>
                                <div className="tx-hash">
                                    <div className='row-copy'>
                                        <span>
                                            {truncateText(data?.hash)}
                                        </span>
                                        <img
                                            onClick={() => handleCopy(data?.hash)}
                                            className='icon-copy'
                                            src="/images/copy.png"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                {/* <p className="confirmed-text">PWC has confirmed receipt of funds.</p> */}
                            </div>
                            {loadingAction ? (
                                <div className="button-group">
                                    <button className="button primary">
                                        <Spin indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />} />
                                    </button>
                                </div>
                            ) : (
                                <div className="button-group">
                                    <button className="button primary" onClick={handlePwcFinalConfirm}>
                                        PWC Final Confirm Receipt of Funds
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {(data.status === ReconciliationStatus.COMPLETED) && (
                        <div className="modal-step">
                            <h4>Step 4: PWC Receipt Confirmation</h4>
                            <div className="info-box receipt-box receipt-box-completed">
                                <div>Meteora Pay has submitted Tx Hash:</div>
                                <div className="tx-hash">
                                    <div className='row-copy'>
                                        <span>
                                            {truncateText(data?.hash)}
                                        </span>
                                        <img
                                            onClick={() => handleCopy(data?.hash)}
                                            className='icon-copy'
                                            src="/images/copy.png"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div className="confirmed-text">PWC has confirmed receipt of funds.</div>
                            </div>
                        </div>
                    )}



                    {data.status === ReconciliationStatus.COMPLETED && (
                        <div className="modal-step">
                            <h4>Step 5: Completed</h4>
                            <div className="info-box">
                                <p>Reconciliation completed successfully.</p>
                            </div>
                        </div>
                    )}
                </div>
                <footer className="modal-footer">
                    <button onClick={onClose} className="button default">Close</button>
                </footer>
            </div>
        </div>
    );
};

const ReconciliationPage = () => {
    const [statusFilter, setStatusFilter] = useState('');
    const [startDate, setStartDate] = useState<any>('');
    const [endDate, setEndDate] = useState<any>('');
    const [modalData, setModalData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    const [reconciliationData, setReconciliationData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingAction, setLoadingAction] = useState<boolean>(false);

    // console.log('reconciliationData', reconciliationData);

    const getReconciliationData = async () => {
        setLoading(true);
        try {
            let params = {
                status: statusFilter,
                startDate: startDate ? startDate?.format('YYYY-MM-DD') : '',
                endDate: endDate ? endDate?.format('YYYY-MM-DD') : '',
                page: currentPage,
                limit: pageSize,
            };
            // console.log(params);
            const res = await AdminApi.GetListReconciliation(params);
            if (res?.data?.success) {
                setReconciliationData(res?.data?.data);
                setTotalItems(res?.data?.meta?.totalItems);
            } else {
                setReconciliationData([]);
                setTotalItems(0);
            }
        } catch (err: any) {
            setReconciliationData([]);
            setTotalItems(0);
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const handleProcessClick = (data: any) => setModalData(data);
    const handleCloseModal = () => setModalData(null);

    // Reset về trang 1 khi filter thay đổi
    React.useEffect(() => {
        setCurrentPage(1);
    }, [statusFilter, startDate, endDate]);

    const getReconciliationStatusClass = (status: any) => {
        switch (status) {
            case ReconciliationStatus.COMPLETED: return 'status-completed';
            case ReconciliationStatus.AWAITING_TOPUP: return 'status-awaiting';
            case ReconciliationStatus.PENDING_PWC_CONFIRM: return 'status-pending-pwc';
            case ReconciliationStatus.PENDING_METEORA_CONFIRM: return 'status-pending-meteora';
            case ReconciliationStatus.PENDING_PWC_FINAL_CONFIRM: return 'status-pending-pwc-final';
            default: return '';
        }
    };

    useEffect(() => {
        getReconciliationData();
    }, [currentPage, statusFilter, startDate, endDate]);

    function renderTextStatus(status: any) {
        switch (status) {
            case ReconciliationStatus.PENDING_METEORA_CONFIRM: return 'Pending Meteora Confirmation';
            case ReconciliationStatus.PENDING_PWC_CONFIRM: return 'Pending PWC Confirmation';
            case ReconciliationStatus.AWAITING_TOPUP: return 'Awaiting Top-up';
            case ReconciliationStatus.PENDING_PWC_FINAL_CONFIRM: return 'Pending PWC Final Confirmation';
            case ReconciliationStatus.COMPLETED: return 'Completed';
            default: return '';
        }
    }

    return (
        <div className="page active">
            <h1 className="reconciliation-page-title">Daily Financial Reconciliation</h1>
            <div className="content-card">
                <div className="reconciliation-filters">
                    <div className="status-filter">
                        <label htmlFor="recon-status-filter">Status:</label>
                        <Select
                            id="recon-status-filter"
                            value={statusFilter}
                            onChange={(value) => setStatusFilter(value)}
                            className="recon-status-select"
                            style={{ width: '100%' }}
                            options={[
                                { value: '', label: 'All' },
                                { value: ReconciliationStatus.PENDING_METEORA_CONFIRM, label: 'Pending Meteora Confirmation' },
                                { value: ReconciliationStatus.PENDING_PWC_CONFIRM, label: 'Pending PWC Confirmation' },
                                { value: ReconciliationStatus.AWAITING_TOPUP, label: 'Awaiting Top-up' },
                                { value: ReconciliationStatus.PENDING_PWC_FINAL_CONFIRM, label: 'Pending PWC Final Confirmation' },
                                { value: ReconciliationStatus.COMPLETED, label: 'Completed' },
                            ]}
                        />
                    </div>
                    <div className="date-range-filter">
                        <label>Date:</label>
                        <RangePicker
                            value={startDate && endDate ? [startDate, endDate] : null}
                            onChange={(dates) => {
                                setStartDate(dates?.[0] || null);
                                setEndDate(dates?.[1] || null);
                            }}
                            format="YYYY-MM-DD"
                            className="recon-date-range-picker"
                        />
                    </div>
                </div>
                <div className="table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Total Volume (USDT)</th>
                                <th>Status</th>
                                <th>Meteora Confirmation</th>
                                <th>PWC Confirmation</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <>
                                    <tr>
                                        <td colSpan={6}>
                                            <div className="box-nodata">
                                                <LoadingTable />
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            ) : (
                                <>
                                    {reconciliationData.length > 0 ? reconciliationData.map((item: any) => (
                                        <tr key={item.id}>
                                            <td data-label="Date">
                                                {formatTimestamp(item.updatedAt)}
                                            </td>
                                            <td data-label="Total Volume (USDT)">
                                                {formatNumber(item.total_volume, 2)}
                                            </td>
                                            <td data-label="Status">
                                                <span
                                                    className={`status-badge ${getReconciliationStatusClass(item.status)}`}
                                                    style={{ textTransform: 'capitalize' }}
                                                >
                                                    {renderTextStatus(item.status)}
                                                </span>
                                            </td>
                                            <td
                                                data-label="Meteora Confirmation"
                                                className={item.partner_confirmation ? 'confirmed' : 'pending'}>
                                                {item.partner_confirmation ? 'Confirmed' : 'Pending'}
                                            </td>
                                            <td
                                                data-label="PWC Confirmation"
                                                className={item.pwc_confirmation ? 'confirmed' : 'pending'}>
                                                {item.pwc_confirmation ? 'Confirmed' : 'Pending'}
                                            </td>
                                            <td data-label="Action">
                                                <button
                                                    onClick={() => handleProcessClick(item)}
                                                    className="action-button">
                                                    Process
                                                </button>
                                            </td>
                                        </tr>
                                    )) : <tr>
                                        <td colSpan={6} className="no-data">No records found.</td>
                                    </tr>
                                    }
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
                {reconciliationData.length > 0 && (
                    <div className="pagination-wrapper">
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={totalItems}
                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} records`}
                            onChange={(page, size) => {
                                setCurrentPage(page);
                            }}
                        />
                    </div>
                )}
            </div>
            {modalData &&
                <ReconciliationModal
                    data={modalData}
                    onClose={handleCloseModal}
                    getReconciliationData={getReconciliationData}
                    loadingAction={loadingAction}
                    setLoadingAction={setLoadingAction}
                />}
        </div>
    );
};

export default ReconciliationPage;